import { useMemo } from 'react'

import { cn } from '@fortem-monorepo/js-utilities'
import { numberFormatter } from '@fortem-monorepo/js-utilities'
import { getBasicColDefsFromData } from '@fortem-monorepo/react-ag'
import { CustomAgGrid } from '@fortem-monorepo/react-ag'
import { Widget, WidgetContent, WidgetHeaderWithQuery } from '@fortem-monorepo/react-spa'

import { BaseICReportPrimitive } from '@/pages/funds/ic-report/components/primitives/types'
import { labels } from '@/pages/funds/ic-report/constants'
import { income } from '@/react-query/queries/ic-report/hooks'

export type BucketVsOvernightProps = BaseICReportPrimitive & {}

export const BucketVsOvernight: React.FC<BucketVsOvernightProps> = ({ params }) => {
  const query = income.useBucketVsOvernightDifferences(params)

  const entries = useMemo(() => {
    return Object.entries(query.data ?? {})
  }, [query.data])

  const noData = !entries || entries?.length === 0

  return (
    <Widget className={cn({ 'min-h-75!': query.isLoading || noData })}>
      <WidgetHeaderWithQuery
        title={`${labels.income.costs_over_income().widgetTitle}`}
        query={query}
      />
      <WidgetContent loading={query.isLoading} className={'flex-1'}>
        {!noData ? (
          <div className="flex gap-4 p-4 min-h-full flex-1">
            {entries.map(([title, data]) => {
              return (
                <Widget className={'flex-1! w-auto!'}>
                  <WidgetHeaderWithQuery title={title} />
                  <WidgetContent className={'min-h-full!'}>
                    <CustomAgGrid
                      statusBar={{ statusPanels: [] }}
                      rowData={data as any[]}
                      // @ts-ignore
                      columnDefs={[
                        ...getBasicColDefsFromData(data as any[]).filter(
                          (col) => col.field !== 'index',
                        ),
                        { field: 'index', hide: true },
                      ].map((col) => ({
                        ...col,
                        valueFormatter: (params: any) =>
                          typeof params?.value === 'number'
                            ? numberFormatter({ suffix: '%' })(params)
                            : undefined,
                        cellClassRules: {
                          'text-center': (params: any) => {
                            return typeof params?.value === 'number'
                          },
                        },
                      }))}
                    />
                  </WidgetContent>
                </Widget>
              )
            })}
          </div>
        ) : (
          <div
            className={
              'absolute top-0 left-0 items-center justify-center w-full h-full flex text-xs'
            }
          >
            No rows to show
          </div>
        )}
      </WidgetContent>
    </Widget>
  )
}
